// extracted by mini-css-extract-plugin
export default {"root":"DerogatoryDialog_root__iWLJZ","extenuatingField":"DerogatoryDialog_extenuatingField__vtBmF"};